module.exports = __webpack_public_path__ + "img/black.47109d04.png";